import type { SyntheticEvent } from 'react';
import React from 'react';
import { ImOkStatusType } from '../../utils/enums';
import type { ImOkUser } from '../../containers/ImOkList/imOkSlice/types';
import { useNavigate } from 'react-router-dom';
import {
  SwitchButtonText,
  UserButton,
  UserColumn,
  UserContainer,
  UserLocation,
  UserStatus,
} from './ImOk.styles';
import { translate } from '../../utils/translate';
import { getNumbersBasedDateTextByLanguage } from '../../utils/date';
import locationActive from '../../assets/icons/location-marker--yellow.svg';
import locationInActive from '../../assets/icons/location-marker--grey.svg';

type ImOkUserProps = {
  user: ImOkUser;
  selectedGroup: Icon;
  groupId: number;
  iAmOkId: number;
  handleMapClick?: () => void;
};

export type Icon = {
  id: ImOkStatusType;
  text: string;
  count: number | undefined;
  color: string;
  align: string;
};

const ImOkUserItem = (props: ImOkUserProps) => {
  const { user, selectedGroup, groupId, iAmOkId, handleMapClick } = props;
  const {
    userid,
    username,
    lastupdated,
    locationLatitude: latitude,
    locationLongitude: longitude,
  } = user;
  const navigation = useNavigate();
  const activeIcon = latitude && longitude;
  const handleMemberSelected = () => {
    return navigation(`/muster/${iAmOkId}/memberSettings/${groupId}/${userid}`);
  };

  const onMapClick = (e: SyntheticEvent) => {
    e.stopPropagation();
    handleMapClick?.();
  };

  return (
    <UserContainer onClick={() => handleMemberSelected()} role={`imOkUser-${username}`}>
      <UserColumn role="userInfoRow">
        {selectedGroup.id !== ImOkStatusType.NoStatus && (
          <SwitchButtonText role="selectedResponse" $morePadding color={selectedGroup.color}>
            {translate(selectedGroup.text)}
          </SwitchButtonText>
        )}
        <UserButton role="username">{username}</UserButton>
      </UserColumn>
      <UserColumn role="dateAndLocationRow">
        <UserStatus role="dateText" paddingRight={selectedGroup.id !== ImOkStatusType.NoStatus}>
          {selectedGroup.id === ImOkStatusType.NoStatus && translate(selectedGroup.text)}
          {selectedGroup.id !== ImOkStatusType.NoStatus &&
            getNumbersBasedDateTextByLanguage({ dateText: lastupdated, showOnlyTimeIfToday: true })}
        </UserStatus>
        {selectedGroup.id !== ImOkStatusType.NoStatus && (
          <UserLocation
            role="userLocation"
            onClick={onMapClick}
            src={activeIcon ? locationActive : locationInActive}
          />
        )}
      </UserColumn>
    </UserContainer>
  );
};

export default ImOkUserItem;
